module.exports = __webpack_public_path__ + "img/任意角度.f80dc633.svg";